var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { getAreNumbersLoadedSelector, getNumbersSelector } from '../pricing-numbers.reducer';
import { debounceTime, distinctUntilChanged, startWith } from 'rxjs/operators';
import { AccountService } from '../../../shared/services/account.service';
import { Location } from '@angular/common';
import { ClearNumbersLoadedStateAction, GetNumbersAction } from '../pricing-numbers.action';
import { AmplitudeService } from '../../../shared/services/amplitude.service';
var ChooseNumberComponent = /** @class */ (function () {
    function ChooseNumberComponent(fb, route, store, router, accountService, location, amplitudeService) {
        this.fb = fb;
        this.route = route;
        this.store = store;
        this.router = router;
        this.accountService = accountService;
        this.location = location;
        this.amplitudeService = amplitudeService;
    }
    ChooseNumberComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.filtersForm = this.fb.group({
            search: ['']
        });
        this.pricingId = this.route.snapshot.params['pricingId'];
        this.phoneNumbers$ = this.store.select(getNumbersSelector);
        this.arePhoneNumbersLoaded$ = this.store.select(getAreNumbersLoadedSelector);
        this.filtersForm.controls['search'].valueChanges
            .pipe(startWith(''), debounceTime(300), distinctUntilChanged())
            .subscribe(function (searchText) {
            _this.store.dispatch(new GetNumbersAction({ pricingId: _this.pricingId, searchText: searchText }));
        });
        this.logAmplitude('Init');
    };
    ChooseNumberComponent.prototype.ngOnDestroy = function () {
        this.store.dispatch(new ClearNumbersLoadedStateAction());
    };
    ChooseNumberComponent.prototype.refreshNumbers = function () {
        var searchText = this.filtersForm.controls['search'].value;
        this.store.dispatch(new GetNumbersAction({ pricingId: this.pricingId, searchText: searchText }));
        this.logAmplitude('Refresh numbers');
    };
    ChooseNumberComponent.prototype.noNumbersForPricing = function (numbers) {
        return !this.numbersForPricingExists(numbers);
    };
    ChooseNumberComponent.prototype.numbersForPricingExists = function (numbers) {
        return numbers.length || this.userFilteredNumbers();
    };
    ChooseNumberComponent.prototype.chooseNumber = function (number) {
        var _this = this;
        this.logAmplitude('Number chosen', number);
        this.accountService.getAccountConfig().subscribe(function (conf) {
            var isFullyConfigured = conf.data;
            var baseUrl = isFullyConfigured ? 'get-new-number' : 'get-first-new-number';
            _this.router.navigate([baseUrl, 'pricing', _this.pricingId, 'final-step'], {
                queryParams: {
                    selectedNumber: number.number,
                    selectedMsisdnId: number.id
                }
            });
        });
    };
    ChooseNumberComponent.prototype.back = function () {
        this.logAmplitude('Going back');
        this.location.back();
    };
    ChooseNumberComponent.prototype.userFilteredNumbers = function () {
        return this.filtersForm.get('search').value !== '';
    };
    ChooseNumberComponent.prototype.logAmplitude = function (event, properties) {
        if (properties === void 0) { properties = {}; }
        this.amplitudeService.logEvent("Panel:Numbers:Choose number table: " + event, __assign({ pricingId: this.pricingId }, properties));
    };
    return ChooseNumberComponent;
}());
export { ChooseNumberComponent };
